<template>
    <div id="vue-search" class="search">
        <span :class="['search__icon', { 'search__icon--loading': showLoader }]" aria-hidden="true">
            <svg class="search__icon-glass" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <circle cx="7" cy="7" r="5.5" stroke="currentColor" stroke-width="1.5"/>
                <line x1="11.5" y1="11.5" x2="15" y2="15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            <svg class="search__icon-spinner" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <circle cx="7" cy="7" r="5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-dasharray="26 9"/>
            </svg>
        </span>
        <input
            data-cy="search-community"
            ref="search"
            :value="search"
            @input="(ev) => (search = ev.target.value)"
            @keyup="(event) => getInput(true, event)"
            class="c-textbox c-textbox--communities"
            type="text"
            :placeholder="placeholder"
        >
        <span
            :class="['search__clear', showReset ? 'search__active' : '']"
            @click="clearInput"
            aria-label="Clear search"
        >
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
        </span>
        <div class="c-community__search-message" v-html="searchMeta"></div>
    </div>
</template>

<script>
import MasonryStore from '../../configs/masonry-store';

export default {
    data() {
        return {
            communityId: this.$root.community.id,
            loading: false,
            masonry: MasonryStore,
            next: true,
            page: 1,
            search: null,
            searchMeta: '',
            showLoader: false,
            showReset: false,
        };
    },
    watch: {
        $route(to, from) {
            this.$refs.search.focus();
            let hash = this.$simpleStore.getHash();
            if (
                from.fullPath.indexOf('#') !== -1 &&
                to.fullPath.indexOf('#') === -1 &&
                hash.length > 1
            ) {
                this.$root.$emit('bus-communitycards-reset');
            }
        },
    },
    computed: {
        searchType() {
            if (this.$root.$route.path.indexOf('/members') !== -1) {
                return 'member';
            }
            if (this.$root.$route.path.indexOf('/hashtags') !== -1) {
                return 'hashtag';
            }
            return 'content';
        },
        contentType() {
            switch (this.$root.$route.name) {
                case 'communityOfficialPosts': return 'official';
                case 'communityArticlePosts':  return 'articles';
                case 'communityReposts':       return 'reposts';
                default:                       return 'all';
            }
        },
        placeholder() {
            let placeholder = 'Search ';
            switch (this.searchType) {
                case 'member':
                    placeholder += 'Members';
                    break;
                case 'hashtag':
                    placeholder += '#Tags';
                    break;
                default:
                    if (this.$simpleStore.getHash(true) === '') {
                        placeholder += 'Content';
                    } else {
                        placeholder = '#' + this.$simpleStore.getHash(true);
                    }
            }
            return placeholder;
        },
        endpoint() {
            let endpoint = '/';
            switch (this.searchType) {
                case 'member':
                    endpoint += 'sm';
                    break;
                case 'hashtag':
                    endpoint += 'sh';
                    break;
                default:
                    endpoint += 'api/v1/sc';
            }
            return endpoint;
        },
        resetEvent() {
            let resetEvent = 'bus-communitycards-reset';
            switch (this.searchType) {
                case 'member':
                    resetEvent = 'bus-CommunityMembers-reset';
                    break;
                case 'hashtag':
                    resetEvent = 'reset-hashtags';
                    break;
            }
            return resetEvent;
        },
        addEvent() {
            let addEvent = 'bus-communitycards-add';
            switch (this.searchType) {
                case 'member':
                    addEvent = 'bus-communitymembers-update';
                    break;
                case 'hashtag':
                    addEvent = 'add-hashtags';
                    break;
            }
            return addEvent;
        },
        updateEvent() {
            let updateEvent = 'bus-communitycards-update';
            switch (this.searchType) {
                case 'member':
                    updateEvent = 'bus-communitymembers-update';
                    break;
                case 'hashtag':
                    updateEvent = 'update-hashtags';
                    break;
            }
            return updateEvent;
        },
    },
    mounted() {
        // Add focus to search input on page load
        this.$refs.search.focus();
        this.scrollResults();
    },
    methods: {
        clearInput() {
            setTimeout(() => { this.showReset = false; }, 400);
            this.search = '';
            this.page = 1;
            this.loading = false;
            this.$root.search = '';
            this.$root.$emit(this.resetEvent);
            this.$refs.search.focus();
        },
        getInput(resetPaging, event) {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.loading = true;
            // get input after 800ms i.e. once user has stopped typing
            this.timer = setTimeout(() => {
                if (resetPaging) {
                    this.page = 1;
                }
                if (this.search.length > 0) {
                    // if user types a hashtag directly in search bar then reload to get full functionality with the hashtag
                    if (this.search.substring(0, 1) === '#') {
                        window.location.hash = this.search;
                        window.location.reload();
                        return;
                    }
                    this.showReset = true;
                    this.showLoader = true;
                    if (this.page === 1 && this.searchType === 'content') {
                        this.$root.$emit('bus-communitycards-initial-placeholder');
                    }
                    this.$root.search = this.search;
                    this.$http
                        .post(this.endpoint + '/' + this.communityId, {
                            term: this.search,
                            page: this.page,
                            type: this.searchType === 'content' ? this.contentType : undefined,
                        })
                        .then(
                            (response) => {
                                if (
                                    response.data == null ||
                                    response.data === '' ||
                                    (Array.isArray(response.data) && response.data.length === 0) ||
                                    (response.data.cards !== undefined && response.data.cards.length === 0) ||
                                    (response.data.cards === undefined && !Array.isArray(response.data))
                                ) {
                                    this.showLoader = false;
                                    this.showReset = true;
                                    if (this.searchType === 'content') {
                                        this.$root.$emit('bus-communitycards-search-noresults', this.search);
                                    }
                                } else {
                                    this.$root.$emit(
                                        this.page === 1
                                            ? this.addEvent
                                            : this.updateEvent,
                                        response.data
                                    );
                                    this.page++;
                                    this.loading = false;
                                    this.showLoader = false;
                                    this.showReset = true;
                                    this.masonry.load();
                                }
                            },
                            (response) => {
                                this.showLoader = false;
                                console.log('Errored:');
                                console.log(response);
                            }
                        );
                } else {
                    this.showReset = false;
                    this.$root.$emit(this.resetEvent);
                }
            }, 800);
        },
        scrollResults() {
            window.addEventListener('scroll', () => {
                // if there is no active content search do not scroll
                if (
                    typeof this.$root.search == 'undefined' ||
                    this.$root.search.length === 0
                ) {
                    return;
                }
                let scrollHeight = Math.max(
                    window.scrollY,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                // only calculate scroll height when not loading and when there are more posts to load
                if (this.loading === false && this.next) {
                    let percentageScroll =
                        (scrollHeight + window.innerHeight) /
                        document.documentElement.offsetHeight;
                    // load more posts when scrolled 90% of screen height
                    if (percentageScroll > 0.9) {
                        this.getInput(false);
                    }
                }
            });
        },
    },
};
</script>
